import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryPipe } from './country.pipe';

@NgModule({
  declarations: [CountryPipe],
  exports: [CountryPipe],
  imports: [CommonModule],
})
export class CountryPipeModule {}
